import { render, staticRenderFns } from "./CheckoutFreeItem.vue?vue&type=template&id=2ffed5a8&"
import script from "./CheckoutFreeItem.js?vue&type=script&lang=js&"
export * from "./CheckoutFreeItem.js?vue&type=script&lang=js&"
import style0 from "./CheckoutFreeItem.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports